import { useState, useEffect } from "react";
import axios from "axios";
import adImage from "../Assets/images/ad.png";
import adImage2 from "../Assets/images/ad2.png";
import { getMediaBaseUrl } from "../utils/backendUrl";

const LeftAdBanner = () => {
  const [adImages, setAdImages] = useState([
    adImage,
    adImage2
  ]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  const baseUrl = getMediaBaseUrl();

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}message`);
        const items = Array.isArray(res?.data) ? res.data : [];

        // Only vertical type + active ads from backend
        const verticalAds = items
          .filter((ad) => ad.type === "vertical" && ad.is_active)
          .map((ad) =>
            ad.image
              ? `${baseUrl}/uploads/messages/${ad.image}`
              : adImage
          );

        if (verticalAds.length > 0) {
          setAdImages(verticalAds);
        }
      } catch (err) {
        console.error("Failed to fetch vertical ads", err);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentAdIndex((prev) => (prev + 1) % adImages.length);
    }, 4000); // Change image every 4 seconds
    return () => clearInterval(intervalId);
  }, [adImages.length]);

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden flex flex-col items-center shadow-sm relative h-[600px] group cursor-pointer">
      <div className="absolute top-0 right-0 bg-black/50 text-white text-[9px] uppercase px-2 py-0.5 font-bold z-20 tracking-widest">Ad</div>
      
      {adImages.map((ad, i) => (
        <img 
          key={i}
          src={ad} 
          alt={`Left Sidebar Ad ${i + 1}`} 
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${i === currentAdIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
        />
      ))}

      {/* Dots Indicator */}
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-20">
        {adImages.map((_, i) => (
          <button 
            key={i} 
            onClick={(e) => {
              e.stopPropagation();
              setCurrentAdIndex(i);
            }}
            className={`w-2 h-2 rounded-full shadow-md transition-all ${i === currentAdIndex ? 'bg-brand-red scale-125' : 'bg-white/70 hover:bg-white'}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default LeftAdBanner;
